import { render, staticRenderFns } from "./KeywordNavigation.vue?vue&type=template&id=b34118de&scoped=true"
import script from "./KeywordNavigation.vue?vue&type=script&lang=js"
export * from "./KeywordNavigation.vue?vue&type=script&lang=js"
import style0 from "./KeywordNavigation.vue?vue&type=style&index=0&id=b34118de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b34118de",
  null
  
)

export default component.exports